import { Row, Col, Form, Button, Tab, Table, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Css from './Customer.module.css';
import ApiConection from 'api_ref/ApiConection';
import { useEffect, useState } from "react";
import { AddCommar, ConvertDateTimeToText, DisplayPaging } from "components/MyControl";
import Layout4Admin1 from "components/layout/Layout4Admin1";
import AdminTable from "./AdminTable";
import Footer4Bottom1 from "components/layout/Foot4Bottom1";
import AccountFilter from "./AccountFilter";
import UtilClass from "api_ref/UtilClass";

export default function AccountWaitInvoice() {
    const navigate = useNavigate();

    const api = new ApiConection();
    const util = new UtilClass();

    const [loading, setLoading] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [condition, setCondition] = useState({
    });
    const [pagination, setPagination] = useState({
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    })
    const [search, setSearch] = useState({
        company_name: '',
        order_by: 'QuontationNumber',
        order_mode: 'desc',
        page: util.getCombinedSessionStorage('/account/quontation-list','page') ?? 1,
        size: util.getCombinedSessionStorage('/account/quontation-list','size') ?? 10
    })
    const [filterDispaly, setFilterDisplay] = useState(false);

    const getQuontation = async () => {
        //in search it hard code wait to ask later
        let data = {
            search: {
                //payment_status_id:1,
                //audit_status_id:1
            },
            pagination: {
                size: search.size,
                page: search.page,
                order_by: search.order_by,
                order_mode: search.order_mode
            }
        }

        if (search.quontation_number != '')
            data.search.quontation_number = search.quontation_number;
        if (search.company_name != '')
            data.search.company_name = search.company_name;
        if (search.package_short_name != '')
            data.search.package_short_name = search.package_short_name;

        if (search.due_date_from != '')
            data.search.due_date_from = search.due_date_from;
        if (search.due_date_to != '')
            data.search.due_date_to = search.due_date_to;
        if (search.paid_date_from != '')
            data.search.paid_date_from = search.paid_date_from;
        if (search.paid_date_to != '')
            data.search.paid_date_to = search.paid_date_to;

        if (search.payment_status_id != '')
            data.search.payment_status_id = search.payment_status_id;
        if (search.audit_status_id != '')
            data.search.audit_status_id = search.audit_status_id;

        setLoading(true);

        //console.log(data);
        const response_paging = await api.postData(`api/quontation/pagination`, data);
        if (response_paging.status === true) {
            handleSetPagination('record_start', response_paging.data.record_start);
            handleSetPagination('record_count', response_paging.data.record_count);
            handleSetPagination('page_count', response_paging.data.page_count);

            let record_end = response_paging.data.record_start + (search.size - 1);
            if (record_end > response_paging.data.record_count) {
                record_end = response_paging.data.record_count;
            }

            handleSetPagination('record_end', record_end);
        }

        const response = await api.postData(`api/quontation/result`, data);
        setDataList(response.data);
        //console.log(response.data);
        setLoading(false);
    }

    const handleSetCondition = (name, value) => {
        setCondition(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetPagination = (name, value) => {
        setPagination(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;

        util.setCombinedSessionStorage('/account/quontation-list','page',1);
        util.setCombinedSessionStorage('/account/quontation-list','size',value);

        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }
    const handlePagingChange = (page_no) => {

        util.setCombinedSessionStorage('/account/quontation-list','page',page_no);
        handleSetSearch('page', page_no);
    }

    const handleOpenDetail = (quontation_id) => {
        navigate(`/paytransaction/${quontation_id}/detail`);
    }

    useEffect(() => {
        getQuontation();
    }, [])

    useEffect(() => {
        if (search !== undefined) {
            const delay = setTimeout(() => {
                // เรียกใช้ฟังก์ชันสำหรับการคำนวณผลลัพธ์ที่ต้องการ
                getQuontation();
            }, 500);

            return () => clearTimeout(delay);
        }
    }, [search])

    return (
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <div className={Css.Graph_Box + ' shadow'}>
                        <div className={Css.Content}>
                            <AccountFilter title={'รายการทั้งหมด'} search={search} handleSetSearch={handleSetSearch} />
                            <div className="position-relative" >
                                {
                                    loading &&
                                    <div className="position-absolute w-100 h-100 bg-white bg-opacity-50" style={{ zIndex: 5 }}>
                                        <div className="d-flex justify-content-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <AdminTable path={"/account/quontation-list/"} title={"รายการรอจัดทำใบแจ้งหนี้"} search={search} handleSetSearch={handleSetSearch} dataList={dataList} pagination={pagination} />

                                <DisplayPaging rec_start={pagination.record_start}
                                    rec_end={pagination.record_end}
                                    rec_count={pagination.record_count}
                                    onSizeChange={handleSizeTableChange}
                                    cur_page={search.page}
                                    size={search.size}
                                    page_count={pagination.page_count}
                                    onPagingChange={handlePagingChange} />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout4Admin1>
    )
}